/**
 * AutogradingConfiguration component displays the autograding configuration settings for a programming activity.
 * It includes an accordion to toggle the visibility of the configuration details.
 * This component receives props representing different autograding settings and renders them accordingly.
 */

import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

function AutogradingConfiguration({
  isCaseSensitive,
  isIgnoreWhiteSpace,
  isIndentationPercentage,
  iscompareOnlyNumber,
  allow_delimeters,
  errorRate,
  isOrderImportant,
  linkerFlags,
}) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  return (
    <div>
      <Accordion defaultActiveKey="0">
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Autograding Configuration</div>
              <div>
                {isAccordionOpen ? (
                  <RiArrowDropDownLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                ) : (
                  <RiArrowDropRightLine
                    size={35}
                    color="grey"
                    style={{ margin: "-10 0 -10 10" }}
                  />
                )}
              </div>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse in={isAccordionOpen}>
            <Card.Body>
              <div style={{ marginLeft: "18px" }}>
                <div className="row">
                  {isIndentationPercentage ? (
                    <label htmlFor="match">
                      <i>Indentation percentage :</i> Autograder will compute
                      indentation percentage and shows it in the report to
                      instructor.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  {isIgnoreWhiteSpace ? (
                    <label htmlFor="match">
                      <i>Ignore extra white spaces :</i> All the extra white
                      spaces will be ignored, only one whitespace will be
                      considered for comparision.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  {iscompareOnlyNumber ? (
                    <label htmlFor="match">
                      <i>Compare only numbers:</i> Expected output contains only
                      numbers so, autograder will compare only numbers and
                      ignore any other characters or strings.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  {errorRate ? (
                    <label htmlFor="match">
                      <i>Accepted error bound :</i> {Math.abs(errorRate)} i.e if
                      expected answer in X then output in the range [X -{" "}
                      {Math.abs(errorRate)}, X + {Math.abs(errorRate)}] will be
                      accepted.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  {iscompareOnlyNumber && isOrderImportant === false ? (
                    <label htmlFor="match">
                      <i>Order is not important:</i> Output contains integers
                      only and the order of integers doesn't matter.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  {isCaseSensitive ? (
                    <label htmlFor="match">
                      <i>Case sensitive :</i> Output string or character is case
                      sensitive i.e. uppercase and lowercase will be treated as
                      different.
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
                <div className="row">
                  <label htmlFor="match">
                    <i>Allow varied delimitors :</i>{" "}
                    {allow_delimeters?.join(", ")}
                  </label>
                </div>
                <div className="row">
                  {linkerFlags && linkerFlags.length > 0 ? (
                    <label htmlFor="match">
                      <i>Linker flags : </i>
                      {linkerFlags.join(", ")}
                    </label>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
}
export default AutogradingConfiguration;
